// Cart drawer: opens from the header cart link and after add to cart, and re-renders
// its content through the Section Rendering API after every cart change.
(function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const sectionId = drawer.dataset.sectionId;
  const panel = drawer.querySelector('.cart-drawer__panel');
  const CLOSE_ANIMATION_MS = 300;
  let lastFocused = null;

  // Swaps in freshly rendered drawer content (a section HTML string from Shopify).
  function render(sectionHtml) {
    const fresh = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('[data-cart-drawer-content]');
    const current = drawer.querySelector('[data-cart-drawer-content]');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    syncFloatingButton(Number(fresh.dataset.itemCount));
  }

  // The floating cart button (funnel pages only) shows the item count and hides when the cart is empty.
  function syncFloatingButton(itemCount) {
    const button = document.querySelector('[data-cart-fab]');
    if (!button) return;
    button.hidden = itemCount === 0;
    button.querySelector('[data-cart-fab-count]').textContent = itemCount;
  }

  async function refresh() {
    const response = await fetch(`${window.location.pathname}?sections=${sectionId}`);
    if (!response.ok) throw new Error('Cart drawer refresh failed');
    render((await response.json())[sectionId]);
  }

  function open() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('cart-drawer-open');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      panel.focus();
    });
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    setTimeout(() => { drawer.hidden = true; }, CLOSE_ANIMATION_MS);
    if (lastFocused) lastFocused.focus();
  }

  // A free gift line carries a hidden `_gift_for` property naming the product it comes with.
  // It stays only while that product is still in the cart, and never at more than 1.
  // Returns true when it had to change the cart.
  async function enforceGiftRules(cart) {
    const updates = {};
    cart.items.forEach(item => {
      const giftFor = item.properties && item.properties._gift_for;
      if (!giftFor) return;
      const hasProduct = cart.items.some(other =>
        !(other.properties && other.properties._gift_for) && String(other.product_id) === String(giftFor));
      if (!hasProduct) updates[item.key] = 0;
      else if (item.quantity > 1) updates[item.key] = 1;
    });
    if (Object.keys(updates).length === 0) return false;
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    return response.ok;
  }

  async function changeLine(lineKey, quantity) {
    drawer.classList.add('is-busy');
    try {
      const response = await fetch(`${drawer.dataset.changeUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity, sections: sectionId })
      });
      if (!response.ok) throw new Error('Cart change failed');
      const cart = await response.json();
      if (await enforceGiftRules(cart)) await refresh();
      else render(cart.sections[sectionId]);
    } catch {
      const error = drawer.querySelector('[data-cart-error]');
      if (error) error.hidden = false;
    } finally {
      drawer.classList.remove('is-busy');
    }
  }

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-close]')) return close();

    const stepButton = event.target.closest('[data-cart-step]');
    if (stepButton) {
      const quantity = Number(stepButton.dataset.quantity) + Number(stepButton.dataset.cartStep);
      return changeLine(stepButton.dataset.lineKey, Math.max(0, quantity));
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) changeLine(removeButton.dataset.lineKey, 0);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-open]');
    if (!trigger) return;
    event.preventDefault();
    open();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });

  // The cart page changes lines with full page loads, so check the gift rules on every load too.
  fetch('/cart.js')
    .then(response => response.json())
    .then(enforceGiftRules)
    .then(changed => {
      if (!changed) return;
      if (window.location.pathname.endsWith('/cart')) window.location.reload();
      else refresh();
    })
    .catch(() => {});

  window.NurveCartDrawer = { open, close, render, refresh, sectionId };
})();
